import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 20 20" {...props}>
    <g id="组_9221" data-name="组 9221" transform="translate(-1032 -2142)">
      <path
        id="路径_9247"
        data-name="路径 9247"
        d="M12.143,7.857h6.429A1.426,1.426,0,0,1,20,9.286v9.286A1.426,1.426,0,0,1,18.571,20H9.286a1.426,1.426,0,0,1-1.429-1.429V12.143H1.429A1.426,1.426,0,0,1,0,10.714V1.429A1.426,1.426,0,0,1,1.429,0h9.286a1.426,1.426,0,0,1,1.429,1.429Zm0,1.429v1.429a1.426,1.426,0,0,1-1.429,1.429H9.286v5.715a.713.713,0,0,0,.714.714h7.858a.714.714,0,0,0,.714-.714V10a.714.714,0,0,0-.714-.714ZM3.234.93h8.027c0,.394-.394,9.612,0,9.612L10,10.714A.714.714,0,0,0,10.714,10V2.143A.714.714,0,0,0,10,1.429H2.143c-.189,0,1.091-.688,1.091-.5ZM2.857,7.6V4H5.374V2.5H6.417c.143.021.215.041.215.061a.236.236,0,0,1-.031.092,1.658,1.658,0,0,0-.092.583V4H9.18V7.5H8.044V7.042H6.509v2.64H5.4V7.042H3.9V7.6ZM3.9,4.864v1.35H5.4V4.864Zm4.144,1.35V4.864H6.509v1.35H8.044Zm10.527-.5H17.143a2.857,2.857,0,0,0-2.857-2.857V1.429a4.286,4.286,0,0,1,4.286,4.286ZM1.429,14.286H2.857a2.857,2.857,0,0,0,2.857,2.857v1.429a4.286,4.286,0,0,1-4.286-4.286Z"
        transform="translate(1032 2142)"
     fill="#888888"
      />
      <path
        id="路径_9248"
        data-name="路径 9248"
        d="M2.857,6.756v-3h2.1V2.5h.872c.119.017.18.034.18.051a.2.2,0,0,1-.026.077,1.385,1.385,0,0,0-.077.487v.641H8.139V6.679H7.19V6.3H5.908V8.5H4.985V6.3H3.729v.462Zm.871-2.282V5.6H4.985V4.475H3.728ZM7.19,5.6V4.475H5.908V5.6Z"
        transform="translate(1040.643 2150.9)"
        fill="#595959"
      />
      <path
        id="路径_9249"
        data-name="路径 9249"
        d="M12.594,11.429H11.429l2.056,5.678h1.443l1.994-5.678H15.695l-.43,1.2H13.024l-.429-1.2h0Zm.737,2.149h1.626L14.191,16H14.16l-.829-2.424Z"
        transform="translate(1052.122 2161.807) rotate(180)"
        fill="#fff"
      />
    </g>
  </svg>
);

export default CMP;
